import type { ReactElement, ReactNode } from 'react';

interface EmptyStateProps {
  readonly children: ReactNode;
  /** 오류 안내면 alert 로 알리고 빨간 글자로 보인다. */
  readonly isError?: boolean;
}

/** 목록이 비었거나 불러오는 중·실패일 때 카드 안 가운데 안내. */
export const EmptyState = ({ children, isError = false }: EmptyStateProps): ReactElement => (
  <div
    role={isError ? 'alert' : undefined}
    className={`rounded-2xl border border-dashed border-foreground/10 bg-card px-6 py-14 text-center text-sm ${
      isError ? 'text-destructive' : 'text-muted-foreground'
    }`}
  >
    {children}
  </div>
);
